
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import PublicRoutes from "./routes/PublicRoutes";
import HPanelRoutes from "./routes/HPanelRoutes";
import CandidateRoutes from "./routes/CandidateRoutes";
import ScrollToTop from "./components/ScrollToTop";
import './App.css';
import './Style.css';

// Auth Providers
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { CandidateAuthProvider } from './contexts/CandidateAuthContext';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/* 
  basename="/platform-demo", needed to add in <BrowserRouter> for cPanel deployment, 
  and not needed in local
*/

function GAListener() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-63X4YLFDQC", {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <GAListener />   {/* Inside Router */} 
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Routes>
        {/* Public Website Routes */}
        <Route path="/*" element={<PublicRoutes />} />

        {/* Admin Panel Routes */}
        <Route path="/hpanel/*" element={
          <AdminAuthProvider>
            <HPanelRoutes />
          </AdminAuthProvider>
        } />

        {/* Candidate Panel Routes */}
        <Route path="/candidate/*" element={
          <CandidateAuthProvider>
            <CandidateRoutes />
          </CandidateAuthProvider>
        } />
        {/* <Route path="/candidate/*" element={<CandidateRoutes />} /> */}

        {/* Redirect any unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
